import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TooltipWrapper as ZinniaTooltipWrapper } from '@zapier/design-system';
import { Fragment } from 'react';
export function TooltipWrapper({ children, tooltipText, allowMultilineTooltip, isBlock, position, showTooltipOnTouchDevices, tooltipAriaHidden, }) {
    const zinniaProps = Object.assign({ content: tooltipText, allowMultilineTooltip,
        isBlock,
        showTooltipOnTouchDevices,
        tooltipAriaHidden, shouldCorrectPosition: position === 'selfCorrecting' }, (position !== 'selfCorrecting' && { position }));
    return (_jsx(ZinniaTooltipWrapper, Object.assign({}, zinniaProps, { children: () => _jsx(Fragment, { children: children }) })));
}
//# sourceMappingURL=TooltipWrapper.js.map